module.exports = __webpack_public_path__ + "images/poster/type_C_5476fffe9ae35d504ba988290a727692.jpg";